import React, { useState } from 'react'
import { PermissoesInterface } from '../ImportBackend/Interfaces/SistemaModuloPermissaoInterfaces'

export interface LoginStateInterface {
  token: string
  nome: string
  logado: boolean
  esqueceuSenha: boolean
  obrigatorioAlterarSenha: boolean
  idClienteAtual: number
  idUsuario: number
  permissoes: Array<PermissoesInterface>
}

export default function useLoginState () {

  const [loginState, setLoginState] =
    useState<LoginStateInterface>( {
      token: '',
      nome: '',
      idUsuario: 0,
      logado: false,
      esqueceuSenha: false,
      obrigatorioAlterarSenha: false,
      idClienteAtual: 0,
      permissoes: []
    } )

  return { loginState, setLoginState }

}